import {AfterViewInit, Directive, ElementRef, HostListener, OnInit, Renderer2} from '@angular/core';

@Directive({
  selector: '[appTextareaAutoresize]'
})
export class TextareaAutoresizeDirectiveDirective implements AfterViewInit, OnInit {
  private initialHeight: number;

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2) {
  }

  ngOnInit() {
    this.initialHeight = this.elementRef.nativeElement.clientHeight;
  }

  ngAfterViewInit() {
    if (this.elementRef.nativeElement.scrollHeight) {
      this.resize();
    }
  }

  resize() {
      if (this.initialHeight < this.elementRef.nativeElement.scrollHeight) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'height', 0);
        this.renderer.setStyle(this.elementRef.nativeElement, 'height', this.elementRef.nativeElement.scrollHeight + 'px');
      } else {
        this.renderer.setStyle(this.elementRef.nativeElement, 'height', this.initialHeight);
      }
  }

  @HostListener(':input')
  onInput() {
    this.resize();
  }
}
